// Import Packages
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { ObjectInspector, chromeDark } from 'react-inspector';

// Import Material UI
import { CircularProgress, Tooltip } from '@material-ui/core';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';

// Import Recoil
import { alertState, baseOrigin, personalizationState } from '../../../../recoil-store/recoil-state';
import { useRecoilValue, useSetRecoilState } from 'recoil';

// Import Icons
import actionStartedIcon from '../../../../assets/icons/configurationIcons/monitoring-action-started-icon.svg';
import actionCompletedIcon from '../../../../assets/icons/configurationIcons/monitoring-action-completed-icon.svg';
import actionInfoIcon from '../../../../assets/icons/configurationIcons/monitoring-action-info-icon.svg';
import actionErrorIcon from '../../../../assets/icons/configurationIcons/monitoring-action-error-icon.svg';
import automEndIcon from '../../../../assets/icons/configurationIcons/autom-end-log-icon.svg';
import showInsideActionIcon from '../../../../assets/icons/configurationIcons/show-inside-of-action-log-icon.svg';
import logQuickInfoIcon from '../../../../assets/icons/configurationIcons/log-quick-info-icon.svg';
import LogWebhookIcon from '../../../../assets/icons/configurationIcons/Log-webhook-icon.svg';
import LogWarningIcon from '../../../../assets/icons/configurationIcons/Log-warning-icon.svg';

// Import Helper
import { convertTimestampToDate, convertToDateFormat, formatNanosecondsDifference } from '../../../../helpers/helper';

// Import Pages
import { AllOperationLogs } from './AllOperationLogs';




const LogSummaryDetail = ({ data, log, logs, index, handleOpenInfoArea, setOpenEhLogs }) => {
    const personalization = useRecoilValue(personalizationState);
    const base_origin = useRecoilValue(baseOrigin);
    const [openErrorLogDetail, setOpenErrorLogDetail] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const { t } = useTranslation();
    const defaultLibraryImg = `default_library.png`
    const label = "MESSAGES.MONITORING."

    const customTheme = {
        ...chromeDark, // chromeDark temasını baz al
        BASE_BACKGROUND_COLOR: 'transparent', // Arka plan rengini değiştir
        BASE_COLOR: 'black', // Metin rengini değiştir
        TREENODE_FONT_SIZE: '12px',
        TREENODE_LINE_HEIGHT: '1.5',
        ARROW_COLOR: "#5F5F5F"
    };

    const findLogIcon = (tag) => {
        switch (tag) {
            case "action_started":
                return actionStartedIcon
            case "action_ended":
                return actionCompletedIcon
            case "info":
                return actionInfoIcon
            case "error":
                return actionErrorIcon

            default:
                return actionInfoIcon
                break;
        }
    };

    const handleShowQuickInfo = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const handleHideQuickInfo = (e) => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl); // Check if popper is open or not

    return (
        <>
            {data.operation_status === "COMPLETED" && index === 0
                ? <div className={`log-row-container log-summary-container bigger-row ${log.level?.toLowerCase()}`}>
                    <div className="log-row log-summary-row">
                        <img alt="action-completed-icon" className='circle' src={actionCompletedIcon} />
                        <p className='log-action-name log-summary-error'>{t(label + "SUCCESSFUL-IN-OPERATION")}</p>
                    </div>
                    <div className='child-log-row first-child-log success-child-log-row'>
                        <div className="all-logs-quick-info-start">
                            <div className='all-logs-quick-info-timestamp-header'>
                                <PlayCircleFilledWhiteIcon color='red' className='log-action-image' />
                                <span className="info-body-row-value">{t(label + `STARTED-AT`)}</span>
                            </div>
                            <span className="time-of-log">{convertToDateFormat(convertTimestampToDate(logs[0].created_at), personalization.date_format)}</span>
                        </div>
                        <div className="all-logs-quick-info-end">
                            <div className='all-logs-quick-info-timestamp-header'>
                                <img alt="autom-end-icon" src={automEndIcon} className='log-action-image' />
                                <span className="info-body-row-value">{t(label + `ENDED-AT`)}</span>
                            </div>
                            {logs[1]?.created_at
                                ? <span className="time-of-log">{convertToDateFormat(convertTimestampToDate(logs[1].created_at), personalization.date_format)}</span>
                                : <span className="time-of-log">-</span>}
                        </div>
                    </div>
                    <span className='log-summary-total-time-elapsed-container'>
                        {t(label + `TOTAL-TIME-ELAPSED`)}
                        {logs[1]?.created_at ? <strong>{formatNanosecondsDifference(logs[0].created_at, logs[1].created_at)}</strong> : "-"}
                    </span>
                </div>
                : data.operation_status === "CANCELED" && index === 0 && logs[1]?.tag === "autom_cancelled"
                    ? <div className={`log-row-container log-summary-container bigger-row log-canceled`}>
                        <div className="log-row log-summary-row">
                            <img alt="action-info-icon" className='circle' src={actionInfoIcon} />
                            <p className='log-action-name log-summary-canceled'>{t(label + "OPERATION-IS-CANCELED")}</p>
                        </div>
                        <div className='child-log-row first-child-log success-child-log-row'>
                            <div className="all-logs-quick-info-start">
                                <div className='all-logs-quick-info-timestamp-header'>
                                    <PlayCircleFilledWhiteIcon color='red' className='log-action-image' />
                                    <span className="info-body-row-value">{t(label + `STARTED-AT`)}</span>
                                </div>
                                <span className="time-of-log">{convertToDateFormat(convertTimestampToDate(logs[0].created_at), personalization.date_format)}</span>
                            </div>
                            <div className="all-logs-quick-info-end">
                                <div className='all-logs-quick-info-timestamp-header'>
                                    <img alt="autom-end-icon" src={automEndIcon} className='log-action-image' />
                                    <span className="info-body-row-value">{t(label + `CANCELED-AT`)}</span>
                                </div>
                                {logs[1]?.created_at
                                    ? <span className="time-of-log">{convertToDateFormat(convertTimestampToDate(logs[1].created_at), personalization.date_format)}</span>
                                    : <span className="time-of-log">-</span>}
                            </div>
                        </div>
                        <span className='log-summary-total-time-elapsed-container log-canceled'>
                            {t(label + `TOTAL-TIME-ELAPSED`)}
                            {logs[1]?.created_at ? <strong>{formatNanosecondsDifference(logs[0].created_at, logs[1].created_at)}</strong> : "-"}
                        </span>
                    </div>
                    : data.operation_status === "FAILED" && index === 0
                        ? <div className={`log-row-container log-summary-container bigger-row summary-log-error`}>
                            <div className="log-row log-summary-row">
                                <img alt="action-error-icon" className='circle' src={actionErrorIcon} />
                                <p className='log-action-name log-summary-failed'>{t(label + "OPERATION-IS-FAILED")}</p>
                            </div>
                            <div className='child-log-row first-child-log success-child-log-row'>
                                <div className="all-logs-quick-info-start">
                                    <div className='all-logs-quick-info-timestamp-header'>
                                        <PlayCircleFilledWhiteIcon color='red' className='log-action-image' />
                                        <span className="info-body-row-value">{t(label + `STARTED-AT`)}</span>
                                    </div>
                                    {logs[0].created_at
                                        ? <span className="time-of-log">{convertToDateFormat(convertTimestampToDate(logs[0].created_at), personalization.date_format)}</span>
                                        : <span className="time-of-log">-</span>}
                                </div>
                                <div className="all-logs-quick-info-end">
                                    <div className='all-logs-quick-info-timestamp-header'>
                                        <img alt="autom-end-icon" src={automEndIcon} className='log-action-image' />
                                        <span className="info-body-row-value">{t(label + `ENDED-AT`)}</span>
                                    </div>
                                    {logs[logs.length - 1].completed_at
                                        ? <span className="time-of-log">{convertToDateFormat(convertTimestampToDate(logs[logs.length - 1].completed_at), personalization.date_format)}</span>
                                        : <span className="time-of-log">-</span>}
                                </div>
                            </div>
                            <span className='log-summary-total-time-elapsed-container summary-log-error'>
                                {t(label + `TOTAL-TIME-ELAPSED`)}
                                {logs[logs.length - 1].completed_at && logs[0].created_at
                                    ? <strong>{formatNanosecondsDifference(logs[0].created_at, logs[logs.length - 1].completed_at)}</strong> : "-"}
                            </span>
                        </div>
                        : log.tag !== "autom_started" && log.tag !== "autom_ended" && log.tag === "error"
                            ? <div className={`log-row-container log-summary-container bigger-row ${log.level?.toLowerCase()}`}>
                                <div className="log-row log-summary-row">
                                    <img alt="action-error-icon" className='circle' src={actionErrorIcon} />
                                    <p className='log-action-name log-summary-success'>{t(label + "ERROR-IN-OPERATION")}</p>
                                </div>
                                <div className='child-log-row first-child-log error-child-log-row'>
                                    <div className='group-column log-summary-group-column'>
                                        {log.level === "TRIGGER-PARAM" ? <ObjectInspector data={log.text ? JSON.parse(log.text) : {}} theme={customTheme} />
                                            : <p>{log.error}</p>}
                                        <div>
                                            <p>{t(label + "ACTION-ERROR-DETAILS")}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='log-summary-log-item-container'>
                                    <div className="log-row">
                                        <div className='group-column'>-
                                            <div className={`log-level-column log-${log.level?.toLowerCase()}`}>{t(label + `${log.level}`).toUpperCase()}</div>
                                            {/*  */}
                                            <img className='log-action-image'
                                                src={
                                                    (!log.image && log.level === "TRIGGER-PARAM")
                                                        ? LogWebhookIcon
                                                        : (!log.image && log.level === "WARNING")
                                                            ? LogWarningIcon
                                                            : log.image?.includes('data:') ? log.image :
                                                                `${base_origin}/libraries/${!log.image || log.is_system ? "system" : "custom"}/${log.image ? log.image : defaultLibraryImg}`
                                                } alt='action-image' />
                                            <p className='log-action-name' >
                                                {log.action_name ? <>
                                                    {log.label ?
                                                        <span>{log.label}</span> :
                                                        <>
                                                            <span>
                                                                {log.library_label.includes('CUSTOM') ? log.library_name :
                                                                    t("CONTENT.LIBRARY." + log.library_name + ".NAME")}
                                                                {/* {t("CONTENT.LIBRARY." + log.library_name + ".NAME")} */}
                                                            </span>
                                                            <span className='action-library-name-seperator'> - </span>
                                                            <span>
                                                                {log?.library_label?.includes('CUSTOM') ? log?.action_name :
                                                                    t(`CONTENT.LIBRARY.${log.library_name}.ACTION.${log.action_name}`)}
                                                            </span>
                                                        </>
                                                    }

                                                </>
                                                    : log.level === "TRIGGER-PARAM" ? "" : "-"}
                                            </p>
                                            {log.error_handling_executed ? <Tooltip title={t(label + `OPEN-ERROR-HANDLING-LOGS`)} placement="top" >
                                                <div className="all-logs-error-handling-button" onClick={() => setOpenEhLogs(log.group_id)} style={{ width: "20px", height: "20px", alignItems: "center" }}>
                                                    <div className={`error-handling-icon`} >
                                                    </div>
                                                </div>
                                            </Tooltip> : ""}
                                        </div>
                                        <div className='all-logs-log-action-container' >
                                            <img alt="log-quick-info-icon" className='all-logs-quick-info-icon' src={logQuickInfoIcon} onMouseEnter={handleShowQuickInfo} onMouseLeave={handleHideQuickInfo}
                                                onClick={() => handleOpenInfoArea(log)} />
                                            <img alt="show-inside-action-icon" className='expand-collapse-icon' src={showInsideActionIcon}
                                                onClick={() => setOpenErrorLogDetail((pre) => {
                                                    if (log.parent_id) {
                                                        return { type: "parent_id", parentId: log.parent_id, groupId: log.group_id }
                                                    }
                                                    else {
                                                        return { type: "group_id", parentId: "", groupId: log.group_id }
                                                    }
                                                })} />
                                        </div>
                                        <Popper open={open} anchorEl={anchorEl} style={{ minWidth: 213, minHeight: 134 }} transition placement='top'
                                            container={document.getElementById("operation-log-dialog")} >
                                            {({ TransitionProps }) => (
                                                <ClickAwayListener onClickAway={() => true}>
                                                    <Fade {...TransitionProps} timeout={350}>
                                                        <Paper>
                                                            <div className="all-logs-quick-info-container">
                                                                <div className="all-logs-quick-info-status-container">
                                                                    <span className={`all-logs-quick-info-status-text all-log-${log.level === "INFO" ? "success" : log.level?.toLowerCase()}`}>
                                                                        {log.level === "INFO" ? t(label + `COMPLETED`) : t(label + `${log.level}`)}
                                                                    </span>
                                                                    <div className="all-logs-time-elapsed-container">
                                                                        <span className="all-logs-time-elapsed">{t(label + 'TIME-ELAPSED')}</span>
                                                                        {log.completed_at
                                                                            ? <span className={`log-${log.level?.toLowerCase()}`}>{formatNanosecondsDifference(log.created_at, log.completed_at)}</span>
                                                                            : "-"}
                                                                    </div>
                                                                </div>

                                                                <div className="all-logs-quick-info-start">
                                                                    <div className='all-logs-quick-info-timestamp-header'>
                                                                        <PlayCircleFilledWhiteIcon color='red' className='log-action-image' />
                                                                        <span className="info-body-row-value">{t(label + `STARTED-AT`)}</span>
                                                                    </div>
                                                                    <span className="time-of-log">{convertToDateFormat(convertTimestampToDate(log.created_at), personalization.date_format)}</span>
                                                                </div>
                                                                <div className="all-logs-quick-info-end">
                                                                    <div className='all-logs-quick-info-timestamp-header'>
                                                                        <img alt="autom-end-icon" src={automEndIcon} className='log-action-image' />
                                                                        <span className="info-body-row-value">{t(label + `ENDED-AT`)}</span>
                                                                    </div>
                                                                    {log.completed_at
                                                                        ? <span className="time-of-log">{convertToDateFormat(convertTimestampToDate(log.completed_at), personalization.date_format)}</span>
                                                                        : "-"}
                                                                </div>
                                                            </div>
                                                        </Paper>
                                                    </Fade>
                                                </ClickAwayListener>
                                            )}
                                        </Popper>
                                    </div>
                                </div>
                            </div> : ""
            }
            {openErrorLogDetail && openErrorLogDetail?.type ? <AllOperationLogs data={data} setOpenActivityLog={() => setOpenErrorLogDetail(false)} summaryLog={openErrorLogDetail} /> : ""}
        </>
    )
}

export default LogSummaryDetail